module.exports = __webpack_public_path__ + "static/media/icon-checkmark.c44225e4.svg";